import React, { Fragment, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tooltip } from "antd";
import moment from "moment";
import {
  setTableListData,
  setTableActionDetails
} from "../../actions/tableListing/tableListDataAction";

const MaterialTab = ({ tabTableData, isLoading, OnhandleTableSortColumn }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isO2WPage =
  window.location.pathname.split("/")[1] === "dashboard" ? true : false;
  
  const tableSorting = useSelector(
    (state) => state.TableSortingData.tableListData
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (tabTableData.materialTabsList?.length > 0) {
      setTotalRecords(tabTableData.totalRecords);
      setPageNo(Number(tabTableData.currentPage));
      dispatch(setTableListData(tabTableData.materialTabsList));
    } else {
      setTotalRecords(0);
      setPageNo(1);
    }
  }, [tabTableData.materialTabsList]);

  const handleTableAscDes = (pagination, filters, sorter) => {
    const sortOrder = sorter.order;
    const sortField = sorter.field;
    OnhandleTableSortColumn({
      sortColumn: sortField,
      orderBy:
        sortOrder === "ascend"
          ? "asc"
          : sortOrder === "descend"
          ? "desc"
          : "asc",
      currentPage: pagination.current
    });
  };

  const handleOverviewDetailsPage = (rowData) => {
    dispatch(
      setTableActionDetails({
        labelId: rowData.material_id,
        valueName: rowData.material_Name,
        SapOrderNumber: rowData.sap_Order_Number
      })
    );
    navigate(
      `/${isO2WPage ? "o2w" : "logistic"}/overviewDetails/material/${encodeURIComponent(
        rowData.customer_PO_Number
      )}`
    );
  };

  const tableColumns = [
    {
      title: "Material SAP Code",
      dataIndex: "material_SAP_Code",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "material_SAP_Code"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return (
          <div>
            <Link to={`/detailsView/material/${row.customer_PO_Number}`}>
              <label className="cust_po_no_lbl">{row.material_SAP_Code}</label>
            </Link>
          </div>
        );
      }
    },
    {
      title: "Material Name",
      dataIndex: "material_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "material_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 220,
      render: (_i, row) => {
        return (
          <div>
            <Tooltip placement="bottom" title={row.material_Name}>
              <p>
                {row.material_Name?.length > 20
                  ? row.material_Name.substr(0, 20).concat("..")
                  : row.material_Name}
              </p>
            </Tooltip>
          </div>
        );
      }
    },
    {
      title: "Customer PO Number",
      dataIndex: "customer_PO_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 210,
      render: (_i, row) => {
        return (
          <div>{row.customer_PO_Number ? row.customer_PO_Number : "N/A"}</div>
        );
      }
    },
    {
      title: "Customer Organization Name",
      dataIndex: "customer_Organization_Name",
      sorter: true,
      showSorterTooltip: false,
      width: 280,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            <label>
              {row.customer_Organization_Name}
            </label>
          </div>
        );
      }
    },
    {
      title: "Customer PO Date",
      dataIndex: "customer_PO_Date",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 190,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_PO_Date
              ? moment(row.customer_PO_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      }
    },
    {
      title: "Knack Schedule SO Date",
      dataIndex: "knack_Schedule_SO_Date",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "knack_Schedule_SO_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 250,
      render: (_i, row) => {
        return (
          <div>
            {row.knack_Schedule_SO_Date
              ? moment(row.knack_Schedule_SO_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      }
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (_i, row) => (
        <div
          className="tbl_info_details"
          onClick={() => handleOverviewDetailsPage(row)}
        >
          <InfoCircleTwoTone />
        </div>
      )
    }
  ];
  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 900 }}
        className="dashboard_tables"
        dataSource={tabTableData.materialTabsList}
        loading={isLoading}
        onChange={handleTableAscDes}
        pagination={{
          total: totalRecords,
          pageNo: pageNo,
          pageSize: 10,
          responsive: true,
          showSizeChanger: false,
          current: pageNo,
          onChange: (pageNum) => setPageNo(pageNum)
        }}
        columns={tableColumns}
      />
    </Fragment>
  );
};

export default MaterialTab;
